export function getSearchParams(param, value) {
    const searchParams = new URLSearchParams(window.location.search);

    if (param !== 'page') {
        searchParams.set('page', 1);
    }

    if (value) {
        searchParams.set(param, value);
    } else {
        searchParams.delete(param);
    }

    const newParams = searchParams.toString();

    if (newParams.length) {
        return `${window.location.pathname}?${newParams}`;
    }

    return window.location.pathname;
}

export function updateSearchParams(param, value) {
    const newSearchParams = getSearchParams(param, value);
    history.pushState(null, '', newSearchParams);
}

export function resetSearchParams() {
    history.pushState(null, '', window.location.pathname);
}
